import { z } from "zod";
import { DTOThemeCreatePayload, DTOThemeListResponse, DTOThemeResponse } from "../../../dto";
import { RequestExecutor } from "../../../transport/request-executor";
import { OverridesEndpoint } from "./overrides";

export class ThemesEndpoint {
  readonly overrides: OverridesEndpoint;
  constructor(private readonly requestExecutor: RequestExecutor) {
    this.overrides = new OverridesEndpoint(requestExecutor);
  }

  list(dsId: string, versionId: string) {
    return this.requestExecutor.json(`/design-systems/${dsId}/versions/${versionId}/themes`, DTOThemeListResponse);
  }

  get(dsId: string, versionId: string, themeId: string) {
    return this.requestExecutor.json(
      `/design-systems/${dsId}/versions/${versionId}/themes/${themeId}`,
      DTOThemeResponse
    );
  }

  create(dsId: string, versionId: string, body: DTOThemeCreatePayload) {
    return this.requestExecutor.json(`/design-systems/${dsId}/versions/${versionId}/themes`, DTOThemeResponse, {
      method: "POST",
      body,
    });
  }

  delete(dsId: string, versionId: string, themeId: string) {
    return this.requestExecutor.json(`/design-systems/${dsId}/versions/${versionId}/themes/${themeId}`, z.any(), {
      method: "DELETE",
    });
  }
}
